import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  createVehiculeMovment,
  DayMouvements,
  findDepots,
  ListCamions,
  ListDepots,
} from "../../_App/Redux/Slices/vehicules/vehiculesSlice";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";

const MouvementsDetailsModal = ({
  details,
  setDetails,
  showModal,
  setShowModal,
  load,
  setLoad,
}: any) => {
  const dispatch = useAppDispatch();
  const [mouvements, setMouvements] = useState<any>(undefined);
  const [showForm, setShowForm] = useState(false);

  const depots = useAppSelector(ListDepots);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (showModal) {
      const fetchData = async () => {
        try {
          const res = await dispatch(DayMouvements(details));
          dispatch(findDepots(null));
          if (res.payload.success) setMouvements(res.payload.data);
        } catch (error) {
          console.error(error);
        }
      };

      fetchData();
    }
  }, [dispatch, showModal, details]);

  const close = () => {
    setDetails(undefined);
    setShowModal(false);
    setShowForm(false);
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    const dateTime = `${details.date}T${data.mouvement_time}`;
    const res = await dispatch(
      createVehiculeMovment({
        mouvement_libelle: data.mouvement_libelle,
        vehicule_code: details.vehicule_code,
        date: dateTime,
        chauffeur_code: details.chauffeur_code,
        code: "code",
        depot_code: data.depot_code,
        user_code: details.chauffeur_code,
        region: null,
        zone: null,
        nom_chauffeur: details.nom_chauffeur,
        matricule_vehicule: details.matricule_vehicule,
        marque_vehicule: details.marque_vehicule,
      })
    );
    if (res.payload.success) {
      console.log("Movement created successfully");
      reset();
      setLoad(!load);
      setShowForm(false);
      const updatedMovements = await dispatch(DayMouvements(details));
      if (updatedMovements.payload.success)
        setMouvements(updatedMovements.payload.data);
    }
  };

  return (
    <Modal show={showModal} onHide={() => close()} size="lg">
      <Modal.Header>
        <Modal.Title>
          <span
            className="modal-title"
            id="addCategorieLabel"
            onClick={() => console.log(details)}
          >
            Mouvement de {details.date} de la {details.vehicule_code}
          </span>
        </Modal.Title>
        <button
          type="reset"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => close()}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {mouvements && mouvements.length ? (
          <ul className="timeline">
            {mouvements?.map((item: any, index: number) => (
              <li
                onClick={() => console.log(item)}
                key={index}
                data-date={new Date(item.date).toLocaleTimeString("fr-TN", {
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: false, // 24-hour format
                  timeZone: "Africa/Tunis", // Ensure it's set to Tunisia's timezone
                })}
                className="event"
              >
                <h6>{item.mouvement_libelle}</h6>
              </li>
            ))}
          </ul>
        ) : (
          <div className="row">
            <p>Pas de mouvements !</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!showForm ? (
          <Button className="btn btn-primary" onClick={() => setShowForm(true)}>
            +
          </Button>
        ) : (
          <Form onSubmit={handleSubmit(onSubmit)} className="w-100">
            <Row className="align-items-center">
              <Col md={3}>
                <Form.Select
                  {...register("mouvement_libelle", {
                    required: "Ce champ est requis",
                  })}
                  isInvalid={!!errors.mouvement_libelle}
                >
                  <option value="">Sélectionner un mouvement</option>
                  <option value="entree">Entrée</option>
                  <option value="sortie">Sortie</option>
                  <option value="panne">Panne</option>
                  <option value="assurance">Assurance</option>
                  <option value="entretien">Entretien</option>
                  <option value="visite">Visite</option>
                  <option value="fraud_papier">Fraud Papier</option>
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Select
                  {...register("depot_code", {
                    required: "Ce champ est requis",
                  })}
                >
                  {depots &&
                    depots.map((item, index) => (
                      <option value={item.code}>{item.libelle} </option>
                    ))}
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Control
                  type="time"
                  {...register("mouvement_time", {
                    required: "Ce champ est requis",
                  })}
                  isInvalid={!!errors.mouvement_time}
                />
              </Col>
              <Col md={3} className="d-flex">
                <Button type="submit" className="btn btn-success mr-2">
                  Ajouter
                </Button>
                <Button
                  className="btn btn-secondary"
                  onClick={() => setShowForm(false)}
                >
                  Annuler
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default MouvementsDetailsModal;
